import React from 'react';
import styled from '@emotion/native';
import { useRouter } from 'expo-router';
import { BodyText, H2 } from '@/shared/components/StyledText';
import { darkGreen, sand, welcomeMutedOnGreen } from '@/shared/styles/colors';
import { ROUTES } from '@/shared/constants/routes';
import { useWelcomeSectionLayout } from '@/shared/hooks/useWelcomeSectionLayout';
import {
  FONT_STYLES,
  WELCOME_SECTION_BODY_COPY,
  WELCOME_SECTION_HORIZONTAL_BASE,
  WELCOME_SECTION_HORIZONTAL_RHYTHM_EXTRA,
  WELCOME_SECTION_MAX_WIDTH,
  WELCOME_SECTION_VERTICAL_BASE,
  WELCOME_SECTION_VERTICAL_RHYTHM_EXTRA,
} from '@/shared/styles/constants';
import WelcomeCta from '@/components/welcome/WelcomeCta';

interface LayoutProps {
  isWideLayout: boolean;
}

const SUBHEADLINE_COPY =
  'Get answers to the most common questions before getting started.';

const WelcomeQuestionsFaqSection = () => {
  const { isWide: isWideLayout } = useWelcomeSectionLayout();
  const router = useRouter();

  return (
    <Section isWideLayout={isWideLayout}>
      <SectionInner isWideLayout={isWideLayout}>
        <SectionTitle>Everything you need to know</SectionTitle>
        <Subheadline>{SUBHEADLINE_COPY}</Subheadline>
        <WelcomeCta
          variant="accent"
          onPress={() => router.push(ROUTES.FAQ.path)}
          accessibilityLabel="Visit frequently asked questions"
        >
          Read the FAQ →
        </WelcomeCta>
      </SectionInner>
    </Section>
  );
};

const Section = styled.View<LayoutProps>(({ isWideLayout }) => ({
  width: '100%',
  backgroundColor: darkGreen,
  paddingTop:
    WELCOME_SECTION_VERTICAL_BASE + WELCOME_SECTION_VERTICAL_RHYTHM_EXTRA,
  paddingBottom:
    WELCOME_SECTION_VERTICAL_BASE + WELCOME_SECTION_VERTICAL_RHYTHM_EXTRA,
  paddingHorizontal: isWideLayout
    ? WELCOME_SECTION_HORIZONTAL_BASE
    : WELCOME_SECTION_HORIZONTAL_RHYTHM_EXTRA,
}));

const SectionInner = styled.View<LayoutProps>(({ isWideLayout }) => ({
  width: '100%',
  maxWidth: isWideLayout ? WELCOME_SECTION_MAX_WIDTH : undefined,
  marginLeft: 'auto',
  marginRight: 'auto',
  alignItems: 'center',
}));

const SectionTitle = styled(H2)({
  color: sand,
  textAlign: 'center',
  textTransform: 'uppercase',
  marginBottom: 16,
  letterSpacing: 1,
  fontSize: 30,
  lineHeight: 36,
  width: '100%',
});

const Subheadline = styled(BodyText)({
  color: welcomeMutedOnGreen,
  ...FONT_STYLES.welcomeHelveticaNeue,
  fontSize: WELCOME_SECTION_BODY_COPY.fontSize,
  fontWeight: '300',
  letterSpacing: WELCOME_SECTION_BODY_COPY.letterSpacing,
  lineHeight: 24,
  textAlign: 'center',
  marginBottom: 24,
  maxWidth: 560,
  width: '100%',
});

export default WelcomeQuestionsFaqSection;
